import { InputConfig } from "@cpj-ai/panel-npm-package";
import {
  AuthAccountOrganizationBusinessTypeChoices,
  AuthAccountOrganizationSizeChoices,
  AuthAccountOrganizationStatusChoices,
  useGetIndustriesLazyQuery,
} from "@graphql/generated";

interface IGetInputConfig {
  showExtraFilters?: boolean;
}

export interface ICompanyFilterFormData {
  name?: string;
  shortName?: string;
  industry?: { node: { id: string } };
  businessType?: { value: AuthAccountOrganizationBusinessTypeChoices; label: string };
  sizeGte?: { value: AuthAccountOrganizationSizeChoices; label: string };
  status?: { value: AuthAccountOrganizationStatusChoices; label: string };
  email?: string;
  phone?: string;
  jobPosition?: string;
}

export const getInputConfig = ({ showExtraFilters }: IGetInputConfig): InputConfig[] => {
  return [
    {
      name: "name",
      previewSize: {
        sm: 12,
        lg: 2,
      },
      inputProps: {
        type: "text",
        label: "Company Name",
        placeholder: "Enter name",
      },
    },
    {
      name: "shortName",
      previewSize: {
        sm: 12,
        lg: 2,
      },
      inputProps: {
        type: "text",
        label: "Nik Name",
        placeholder: "Enter Name",
      },
    },
    {
      name: "industry",
      previewSize: {
        sm: 12,
        lg: 2,
      },
      inputProps: {
        type: "searcher",
        label: "Industry",
        placeholder: "Select industry",
        labelKey: "title",
        dataPath: "common.industries",
        valueKey: "id",
        useLazyQuery: useGetIndustriesLazyQuery,
      },
    },
    {
      name: "businessType",
      previewSize: {
        sm: 12,
        lg: 2,
      },
      inputProps: {
        type: "searcher",
        label: "Business Type",
        placeholder: "Select type",
        labelKey: "label",
        valueKey: "value",
        items: Object.entries(AuthAccountOrganizationBusinessTypeChoices)
          .filter(([key]) => isNaN(Number(key)))
          .map(([label, value]) => ({
            label: label.toLowerCase(),
            value,
          })),
      },
      hide: !showExtraFilters,
    },
    {
      name: "sizeGte",
      previewSize: {
        sm: 12,
        lg: 2,
      },
      inputProps: {
        type: "searcher",
        label: "Employee",
        placeholder: "Select employee",
        labelKey: "label",
        valueKey: "value",
        items: [
          {
            label: "1-10",
            value: AuthAccountOrganizationSizeChoices["_1_10"],
          },
          {
            label: "10-50",
            value: AuthAccountOrganizationSizeChoices["_10_50"],
          },
          {
            label: "50-100",
            value: AuthAccountOrganizationSizeChoices["_50_100"],
          },
          {
            label: "100-500",
            value: AuthAccountOrganizationSizeChoices["_100_500"],
          },
          {
            label: "500-1000",
            value: AuthAccountOrganizationSizeChoices["_500_1000"],
          },
          {
            label: "Over 1000",
            value: AuthAccountOrganizationSizeChoices["OVER_1000"],
          },
        ],
      },
      hide: !showExtraFilters,
    },
    {
      name: "email",
      previewSize: {
        sm: 12,
        lg: 2,
      },
      inputProps: {
        type: "text",
        label: "Organizational email",
        placeholder: "Enter email",
      },
      hide: !showExtraFilters,
    },
    {
      name: "phone",
      previewSize: {
        sm: 12,
        lg: 2,
      },
      inputProps: {
        type: "text",
        label: "Organizational phone",
        placeholder: "Enter phone",
      },
      hide: !showExtraFilters,
    },
    {
      name: "jobPosition",
      previewSize: {
        sm: 12,
        lg: 2,
      },
      inputProps: {
        type: "text",
        label: "Job post id",
        placeholder: "Enter job post id",
      },
      hide: !showExtraFilters,
    },
    {
      name: "status",
      previewSize: {
        sm: 12,
        lg: 2,
      },
      inputProps: {
        type: "searcher",
        label: "Status",
        placeholder: "Select status",
        labelKey: "label",
        valueKey: "value",
        items: [
          {
            label: "Drafted",
            value: AuthAccountOrganizationStatusChoices.DRAFTED,
          },
          {
            label: "Rejected",
            value: AuthAccountOrganizationStatusChoices.REJECTED,
          },
          {
            label: "Awaiting approval",
            value: AuthAccountOrganizationStatusChoices.SUBMITTED,
          },
          {
            label: "Verified",
            value: AuthAccountOrganizationStatusChoices.VERIFIED,
          },
          {
            label: "Suspended",
            value: AuthAccountOrganizationStatusChoices.BLOCKED,
          },
          {
            label: "Information Completed",
            value: AuthAccountOrganizationStatusChoices.COMPLETED,
          },
        ],
      },
    },
  ];
};
